module.exports = __webpack_public_path__ + "img/img_wallet-w.9ec9436c.svg";